import { render, staticRenderFns } from "./sky-checkbox.vue?vue&type=template&id=6ed7b265&scoped=true"
import script from "./sky-checkbox.vue?vue&type=script&lang=js"
export * from "./sky-checkbox.vue?vue&type=script&lang=js"
import style0 from "./sky-checkbox.vue?vue&type=style&index=0&id=6ed7b265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7b265",
  null
  
)

export default component.exports